import React from "react";
import { TablePageWrapper, TableTitleTextWrapper, TableTitleWrapper } from "../../common/table/table.style";
import { useResourceContext } from "../../common/resource/useResourceContext";
import { StorageHistory } from "../components/StorageHistory";

export function StorageHistoryPage() {
  const { R } = useResourceContext();

  return (
    <TablePageWrapper>
      <TableTitleWrapper>
        <TableTitleTextWrapper>
          <p className="table-title">{R.text.in_out_history}</p>
        </TableTitleTextWrapper>
      </TableTitleWrapper>

      <StorageHistory />
    </TablePageWrapper>
  );
}
